var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav-menu',_vm._l((_vm.items),function(item){return (_vm.$canAll(item.permissions))?_c('router-link',{key:item.name,attrs:{"to":{ name: item.route }}},[_vm._v(" "+_vm._s(_vm._f("trans")(item.title))+" ")]):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }